import { CollectionFromIframe } from "meta/pages/collection"
import EventListItemSkeleton from "../../EventList/EventListItem/EventListItemSkeleton"
import SeasonListItem from "./SeasonListItem"
import { useTypeTicketCollectionData } from "hooks/useTypeTicketCollection"
import { useCollectionDetails } from "hooks/useCollection"
import { useCurrentLanguage } from "hooks/useCurrentLanguage"

interface Props {
  collectionId: string
  typeticketCollectionId: number
  isPerformer?: boolean
}

const SeasonListItemContainer: React.FC<Props & CollectionFromIframe> = (props) => {
  const { collectionId, typeticketCollectionId, fromIframe, toggleContent, isPerformer } = props

  const typeticketCollectionData = useTypeTicketCollectionData({ id: typeticketCollectionId })

  const language = useCurrentLanguage()

  const eventCollectionData = useCollectionDetails({ id: typeticketCollectionData?.eventCollection?.code ?? 'NONEXISTENTID', language })
  
  if (!typeticketCollectionData ||(isPerformer && !eventCollectionData) ) {
    return <EventListItemSkeleton />
  }

  return <SeasonListItem
    collectionId={isPerformer && eventCollectionData ? eventCollectionData?.codeUrl : collectionId}
    data={typeticketCollectionData}
    fromIframe={fromIframe}
    toggleContent={toggleContent} />
}

export default SeasonListItemContainer